/* ============================================
   No Lo Busques Más – Scroll-Reveal Animations
   ============================================ */
(function () {
  'use strict';

  /* Respect reduced-motion preference */
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Skip entirely inside the Shopify theme editor */
  if (window.Shopify && window.Shopify.designMode) return;

  if (prefersReducedMotion) {
    /* Make every reveal element visible immediately */
    document.querySelectorAll('[data-nlbm-reveal]').forEach(function (el) {
      el.classList.add('nlbm-reveal--visible');
    });
    return;
  }

  function init() {
    var elements = document.querySelectorAll('[data-nlbm-reveal]');
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = el.getAttribute('data-nlbm-delay');

            if (delay) {
              el.style.transitionDelay = delay + 'ms';
            }

            el.classList.add('nlbm-reveal--visible');
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );

    elements.forEach(function (el) {
      el.classList.add('nlbm-reveal');
      observer.observe(el);
    });
  }

  /* Run on DOMContentLoaded or immediately if already loaded */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
